export const UserSummaryMockData = [
  {
    id: '6fc728fa-8be4-eb11-b563-000d3a223e1c',
    displayName: 'Mock User',
    email: 'mockuser@gmail.com',
    createdOn: '0001-01-01T00:00:00+00:00',
    modifiedOn: '0001-01-01T00:00:00+00:00',
    organizations: [
      {
        organizationId: '6c40c6c4-7405-4126-a60d-102f29fd2329',
        organizationDisplayName: 'Mock User Organization',
      },
    ],
    resendInvitation: false,
  },
] as any[];
